import { OrderTypeNameEnum } from '@up/data';

export const mapTableOrKerbCollectionToOrderType = (
  customerOrders: any[]
): any[] => {
  try {
    return customerOrders.map((order) => {
      const extraInfo: {
        [key in OrderTypeNameEnum]: {
          identifier: string;
          registrationPlate: string;
          vehicleColor: string;
          vehicleMake: string;
        };
      } = {
        [OrderTypeNameEnum.TABLE]: {
          identifier: order.table?.identifier ?? null,
          registrationPlate: null,
          vehicleColor: null,
          vehicleMake: null
        },
        [OrderTypeNameEnum.KERB]: {
          identifier: null,
          registrationPlate: order.kerbCollection?.registrationPlate ?? null,
          vehicleColor: order.kerbCollection?.vehicleColor ?? null,
          vehicleMake: order.kerbCollection?.vehicleMake ?? null
        },
        [OrderTypeNameEnum.DELIVERY]: {
          identifier: null,
          registrationPlate: null,
          vehicleColor: null,
          vehicleMake: null
        },
        [OrderTypeNameEnum.COLLECTION]: {
          identifier: null,
          registrationPlate: null,
          vehicleColor: null,
          vehicleMake: null
        }
      };
      const orderTypeName = order.orderType?.name;
      order.orderType = {
        ...order.orderType,
        extraInfo: orderTypeName ? extraInfo[orderTypeName] : null
      };

      delete order.table;
      delete order.kerbCollection;

      return order;
    });
  } catch (error) {
    return customerOrders;
  }
};
